@if (!isInitialDataLoading && !productDetailService.loading) {
  <div class="container-fluid">
    <div class="row">
      <div class="col-12 col-md-3 ps-0 no-p-767">
        <div class="card-smaller card">
          <div class="d-flex justify-content-between">
            <div class="d-flex flex-column align-items-start">
              <div class="available-number" data-cy="quantity-stock">
                {{ productDetailService.totalQuantityStock | number: '1.0-2' | replaceCommaToDot }}
              </div>
              <div class="available-amount">
                {{ 'totalInStock' | translate }}
              </div>
            </div>
            <div>
              <div class="circle-blue">
                <span class="circle-blue-icon"><i class="far fa-warehouse-alt"></i></span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-12 col-md-3 no-p-767">
        <div class="card-smaller card">
          <div class="d-flex justify-content-between">
            <div class="d-flex flex-column align-items-start">
              <div class="available-number" data-cy="quantity-reservation">
                {{ productDetailService.totalQuantityReservation | number: '1.0-2' | replaceCommaToDot }}
              </div>
              <div class="available-amount">
                {{ 'totalReservation' | translate }}
              </div>
            </div>
            <div>
              <div class="circle-red">
                <span class="circle-red-icon"><i class="far fa-hourglass"></i></span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-12 col-md-3 no-p-767">
        <div class="card-smaller card">
          <div class="d-flex justify-content-between">
            <div class="d-flex flex-column align-items-start">
              <div class="available-number" data-cy="quantity-available">
                {{ productDetailService.totalQuantityAvailable | number: '1.0-2' | replaceCommaToDot }}
              </div>
              <div class="available-amount">
                {{ 'totalAvailable' | translate }}
              </div>
            </div>
            <div>
              <div class="circle-green">
                <span class="circle-green-icon"><i class="far fa-check"></i></span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-12 col-md-3 no-p-767">
        <div class="card-smaller card">
          <div class="d-flex justify-content-between">
            <div class="d-flex flex-column align-items-start">
              <div class="available-number" data-cy="quantity-purchase">
                {{ productDetailService.totalQuantityPurchase | number: '1.0-2' | replaceCommaToDot }}
              </div>
              <div class="available-amount">
                {{ 'goodsOnTheWay' | translate }}
              </div>
            </div>
            <div>
              <div class="circle-orange">
                <span class="circle-orange-icon"><i class="far fa-truck"></i></span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-12 col-md-3 d-flex flex-row justify-content-between align-items-center mb-3 no-p-767">
        <form-row-toggle
          class="align-self-center"
          [label]="'isShowingNullPositions'"
          [(model)]="isShowingNullStock"
          [classesString]="'text-nowrap'"
        ></form-row-toggle>
        <btn
          [icon]="'fa-sync'"
          [title]="'product.stock.refresh' | translate"
          [dataCyAttribute]="'product-depots-refresh'"
          (onEvent)="refreshDepotStats()"
        ></btn>
      </div>
    </div>
  </div>
}

<!-- Initial data guard: show loader until product and depots options are ready -->
@if (isInitialDataLoading) {
  <div class="m-3 text-center">
    <loading-spinner [isLoading]="true" [classesString]="'top-50'"></loading-spinner>
  </div>
}

@if (!isInitialDataLoading && productDetailService.isStockEmptyYet) {
  <div class="m-3 text-center">
    <loading-spinner [isLoading]="productDetailService.loading" [classesString]="'top-50'"></loading-spinner>
  </div>
}

@if (!isInitialDataLoading && !productDetailService.loading && productDetailService.isStockEmptyYet) {
  <div class="m-3 text-center">
    {{ 'no.stock.records.yet' | translate }}
  </div>
}
@if (
  !isInitialDataLoading &&
  !productDetailService.loading &&
  (!productDetailService.stock || productDetailService.stock?.length === 0)
) {
  <div class="text-center">
    {{ 'no.records' | translate }}
  </div>
}

@if (
  !isInitialDataLoading &&
  !productDetailService.loading &&
  !productDetailService.isStockEmptyYet &&
  productDetailService.stock?.length > 0
) {
  <div>
    @for (stockItem of productDetailService.stock; track stockItem) {
      <div>
        <div class="card" data-cy="stockItem">
          <div class="table-responsive">
            <div class="d-flex flex-direction-row justify-content-space-between" style="align-items: baseline">
              <div class="text-start ps-0 pt-0" style="flex: 1">
                <div class="flex-direction-column-gap-20">
                  <div>
                    <h2 class="mb-0 text-nowrap align-self-center card-title">
                      {{ 'depot' | translate }} {{ stockItem.depot?.name ? stockItem.depot.name : '' }}
                    </h2>
                  </div>
                </div>
              </div>
              <div class="d-flex align-items-baseline">
                <div class="availability-icons">
                  <div class="flex-gap-5 align-items-center">
                    <div>
                      <i class="far fa-warehouse-alt"></i>
                    </div>
                    <div>
                      {{ stockItem.sumAll | number: '1.0-2' | replaceCommaToDot }}
                    </div>
                  </div>
                  <div class="flex-gap-5 align-items-center">
                    <div>
                      <i class="far fa-hourglass"></i>
                    </div>
                    <div>
                      {{ stockItem.sumReservations | number: '1.0-2' | replaceCommaToDot }}
                    </div>
                  </div>
                  <div class="flex-gap-5 align-items-center">
                    <div>
                      <i class="far fa-check"></i>
                    </div>
                    <div>
                      {{ stockItem.sumAvailable | number: '1.0-2' | replaceCommaToDot }}
                    </div>
                  </div>
                  <div class="flex-gap-5 align-items-center">
                    <div>
                      <i class="far fa-truck"></i>
                    </div>
                    <div>
                      {{ stockItem.sumPurchase | number: '1.0-2' | replaceCommaToDot }}
                    </div>
                  </div>
                </div>
                <app-modal-product-depot-metric [product]="productDetailService.product" [stockItem]="stockItem">
                </app-modal-product-depot-metric>
              </div>
              <div style="flex: 1">&nbsp;</div>
            </div>
            @if (
              (!isShowingNullStock && !areJustNullQuantitiesInTable(stockItem)) ||
              (isShowingNullStock && stockItem.productDepots?.length)
            ) {
              <table class="table m-0">
                <thead>
                  <tr>
                    <th class="text-start ps-0 pt-0">
                      <div class="flex-direction-column-gap-20">
                        <div>
                          {{ 'supplier' | translate }}
                        </div>
                      </div>
                    </th>
                    <th>{{ 'product.batch' | translate }}</th>
                    <th>{{ 'product.expirationDate' | translate }}</th>
                    <th class="text-center">{{ 'position' | translate }}</th>
                    <th class="text-end text-nowrap">{{ 'purchasePrice' | translate }}</th>
                    <th class="text-center pt-0">
                      <div class="flex-direction-column-gap-20">
                        <div>
                          {{ 'products.availability' | translate }}
                        </div>
                      </div>
                    </th>
                    <th class="text-start">{{ 'lastChange' | translate }}</th>
                    <th class="fixed-column-width">&nbsp;</th>
                  </tr>
                </thead>
                <tbody>
                  @for (pDepot of stockItem.productDepots; track trackByFn(i, pDepot); let i = $index) {
                    @if (isShowingNullStock || !(pDepot.quantityStock == 0 && pDepot.quantityReservation == 0)) {
                      <tr>
                        <td class="ps-1 text-nowrap" data-cy="pDepot-supplier">
                          {{ pDepot.supplier ? pDepot.supplier.name : '' }}
                        </td>
                        <td class="text-nowrap" data-cy="pDepot-batch">
                          {{ pDepot.batch }}
                        </td>
                        <td data-cy="pDepot-expirationDate">
                          @if (pDepot.expirationDate) {
                            <span>{{ pDepot.expirationDate | fmtDate: 'dd.MM.yyyy' }}</span>
                          }
                        </td>
                        @if (pDepot.position) {
                          <td class="text-center text-nowrap" data-cy="pDepot-position">
                            {{ pDepot.position }}
                          </td>
                        }
                        <td class="text-end text-nowrap" data-cy="pDepot-purchasePrice">
                          {{ pDepot.purchasePrice | formatPrice }}
                        </td>
                        <td class="text-center text-nowrap">
                          <span class="quantityStock badge badge-pill" data-cy="pDepot-quantityStock">{{
                            pDepot.quantityStock | number: '1.0-2' | replaceCommaToDot
                          }}</span>
                          <span class="quantityReservation badge badge-pill" data-cy="pDepot-quantityReservation">{{
                            pDepot.quantityReservation | number: '1.0-2' | replaceCommaToDot
                          }}</span>
                          <span class="quantityAvailable badge badge-pill" data-cy="pDepot-quantityAvailable">
                            {{ pDepot.quantityAvailable | number: '1.0-2' | replaceCommaToDot }}</span
                          >
                        </td>
                        <td class="text-start text-nowrap">
                          {{ pDepot.updated | date: 'dd.MM.yyyy HH:mm' }}
                        </td>
                        <td>
                          <div class="flex-gap-5 align-items-center">
                            @if (
                              pDepot.depot.enabled && !productDetailService.product.isBundle && pDepot.quantityStock > 0
                            ) {
                              <modal-stock-load
                                [product]="productDetailService.product"
                                [depots]="productDetailService.queryDepotsOptions.data()"
                                [suppliers]="productDetailService.querySuppliers.data()"
                                [currencies]="productDetailService.queryCurrencies.data()"
                                [isUnloadingStock]="true"
                                [currentStockItem]="pDepot"
                                (result)="modalStockResult(pDepot, $event, 'out')"
                              ></modal-stock-load>
                            }
                            @if (pDepot.depot.enabled && !productDetailService.product.isBundle) {
                              <modal-stock-load
                                [product]="productDetailService.product"
                                [depots]="productDetailService.queryDepotsOptions.data()"
                                [suppliers]="productDetailService.querySuppliers.data()"
                                [currencies]="productDetailService.queryCurrencies.data()"
                                [isUnloadingStock]="false"
                                [currentStockItem]="pDepot"
                                (result)="modalStockResult(pDepot, $event, 'in')"
                              ></modal-stock-load>
                            }
                            <modal-stock-positions
                              [(productDepot)]="stockItem.productDepots[i]"
                              [suppliers]="productDetailService.querySuppliers.data()"
                              [productDepot]="pDepot"
                              (result)="modalStockResult(pDepot, $event, 'edit')"
                            ></modal-stock-positions>
                            <btn [icon]="'fa-qrcode'" (onEvent)="printQR(pDepot)"></btn>
                          </div>
                        </td>
                      </tr>
                    }
                  }
                </tbody>
              </table>
            }
          </div>
        </div>
      </div>
    }
  </div>
}
